<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-quotedprice"
    title="立即申请"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
  >
    <el-form :model="formData" :rules="rules" ref="modifyForm">
      <el-form-item prop="mid_table_remark_015">
        <el-input
          class="custom-input"
          v-model="formData.mid_table_remark_015"
          placeholder="请输入联系人"
          maxlength="32"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="mid_table_remark_016">
        <el-input
          class="custom-input"
          v-model="formData.mid_table_remark_016"
          placeholder="请输入联系方式"
          maxlength="11"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="custom-button btn-e0e0e0" @click="handleCloseDialog"
      >取消
      </el-button
      >
      <el-button class="custom-button btn-determine" @click="handleSubmit"
      >确定
      </el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {phoneValidator} from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import needsApi from "@/api/needs";
export default {
  name: "ApplyNeeds",
  mixins: [],
  props: ['needsInfo','userInfo'],
  data() {
    return {
      showDialog: false,
      formData: {
        mid_table_remark_015: this.userInfo.nick_name?this.userInfo.nick_name:'',
        mid_table_remark_016: this.userInfo.user_phone?this.userInfo.user_phone:''
      },
      rules: {
        mid_table_remark_015: [
          {required: true, message: "请填写联系人", trigger: "blur"}
        ],
        mid_table_remark_016: [
          {required: true, message: "请填写联系方式", trigger: "blur"},
          {validator: phoneValidator, trigger: "blur"},
        ]
      },
      isRequesting: false,
    };
  },
  mounted() {
    let _this = this;
  },
  methods: {
    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
    },
    handleSubmit: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      if (this.needsInfo.id_public_middle_table&&this.userInfo.id_public_user_info) {
        _this.$refs["modifyForm"].validate((valid) => {
          if (valid) {
            let requestData = {
              isloading: true,
              id_public_user_info: this.userInfo.id_public_user_info,
              mid_table_remark_001: this.needsInfo.mid_table_remark_001,
              mid_table_remark_002: this.needsInfo.mid_table_remark_002,
              mid_table_remark_004: this.needsInfo.mid_table_remark_004,
              mid_table_remark_005: this.needsInfo.mid_table_remark_005,
              mid_table_remark_006: this.needsInfo.mid_table_remark_006,
              mid_table_remark_007: this.needsInfo.mid_table_remark_007,
              mid_table_remark_008: this.needsInfo.mid_table_remark_008,
              mid_table_remark_009: this.needsInfo.mid_table_remark_009,
              mid_table_remark_010: this.needsInfo.mid_table_remark_010,
              mid_table_remark_011: this.needsInfo.id_public_middle_table,
              mid_table_remark_012: this.userInfo.nick_name,
              mid_table_remark_013: this.userInfo.weichat_img,
              mid_table_remark_014: this.userInfo.user_phone,
              mid_table_remark_015: this.formData.mid_table_remark_015,
              mid_table_remark_016: this.formData.mid_table_remark_016,
              mid_table_remark_017:1701,
              is_online: 0
            }
            pageCommon.apiRequestCommon(needsApi, "insertApplyData", requestData).then(
              (res) => {
                _this.isRequesting = false;
                location.reload();
              },
              (err) => {
                console.log(err)
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
              }
            );
          } else {
            _this.isRequesting = false;
          }
        });
      } else {
        _this.$message.error("页面异常，请稍后刷新重试！");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-quotedprice {
  /deep/ .el-dialog {
    position: absolute;
    width: 650px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 40px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: left;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 0px 40px 0;
      box-sizing: border-box;
    }
    .el-form-item {
      margin-bottom: 30px;
    }
  }
  /deep/ .el-dialog__footer {
    position: relative;
    width: 100%;
    padding: 0;
    padding-bottom: 30px;
    /* padding-top: 0; */
    padding-right: 40px;
  }
  /deep/ .dialog-footer {
    display: flex;
    justify-content: flex-end;
    .custom-button {
      width: 80px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      margin-left: 25px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
